import { styled } from 'solid-styled-components';
import theme from '../../../../style/theme';

export const StyledMenuHeader = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledMenuHeaderTop = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 6.43rem;
`;

export const StyledMenuHeaderIconLinks = styled.div`
    display: flex;
    align-items: center;
    height: 3.86rem;
    /* gap: 0.5rem; */

    justify-content: flex-end;
    margin-left: auto;
`;

export const StyledCrossButton = styled.button`
    padding-inline: 1.43rem;
    padding-left: 2.8rem;

    ${theme.mediaQueries.mobileMax} {
        padding-left: 2.5rem;
    }
`;
